import React, { useEffect, useRef } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ShieldAlert } from 'lucide-react';

const fmt = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

// Modal de bloqueio: venda a prazo estourou o limite do cliente.
// Exige senha de ADMINISTRADOR para autorizar.
export const CreditLimitOverrideModal = ({ show, info, password, setPassword, error, loading, onConfirm, onCancel }) => {
  const inputRef = useRef(null);
  useEffect(() => {
    if (show) setTimeout(() => inputRef.current && inputRef.current.focus(), 60);
  }, [show]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[60] p-3" data-testid="credit-override-overlay">
      <div className="bg-white rounded-lg w-full max-w-md overflow-hidden" data-testid="credit-override-modal">
        <div className="bg-red-600 text-white p-4 flex items-center gap-3">
          <ShieldAlert size={24} />
          <div>
            <h3 className="text-lg font-bold leading-tight">Limite de Crédito Excedido</h3>
            <p className="text-xs text-red-100">Autorização de administrador necessária</p>
          </div>
        </div>

        <div className="p-4 space-y-3">
          {info && (
            <div className="bg-red-50 border border-red-200 rounded p-3 text-sm space-y-1" data-testid="credit-override-info">
              <p className="font-bold text-red-800">{info.customer_name}</p>
              <div className="grid grid-cols-2 gap-1 text-xs text-slate-700">
                <span>Limite:</span><span className="text-right font-bold">{fmt(info.credit_limit)}</span>
                <span>Saldo atual:</span><span className="text-right font-bold">{fmt(info.current_balance)}</span>
                <span>Esta venda a prazo:</span><span className="text-right font-bold">{fmt(info.attempted)}</span>
                <span className="text-red-700 font-bold">Novo saldo:</span><span className="text-right font-black text-red-700">{fmt(info.new_balance)}</span>
              </div>
            </div>
          )}

          <div className="space-y-1">
            <Label className="text-sm font-bold">Senha do Administrador</Label>
            <Input
              ref={inputRef}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onConfirm(); } }}
              placeholder="Digite a senha do admin para liberar"
              data-testid="credit-override-password"
            />
          </div>

          {error && <p className="text-sm text-red-600 font-medium" data-testid="credit-override-error">{error}</p>}

          <div className="flex gap-2 pt-1">
            <Button variant="outline" onClick={onCancel} className="flex-1" data-testid="credit-override-cancel">Cancelar venda</Button>
            <Button onClick={onConfirm} disabled={loading} className="flex-1 bg-red-600 hover:bg-red-700" data-testid="credit-override-confirm">
              {loading ? 'Autorizando...' : 'Autorizar e vender'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
